module.exports = __webpack_public_path__ + "static/media/profilee.48d5dddd.jpg";